import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Theme,
  createStyles,
} from "@material-ui/core";
import { v4 as uuidv4 } from "uuid";
import { AlertDialogData } from "../../types";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleRoot: {
      padding: theme.spacing(1),
    },
    titleText: {
      fontSize: "0.9rem",
      margin: theme.spacing(1),
    },
    contentRoot: {
      padding: "0.25rem",
      margin: 0,
    },
    contentText: {
      lineHeight: "1.1rem",
      padding: theme.spacing(2),
    },
  })
);

/** テキストを改行毎に区切って<p>タグに入れる */
function toParagraph(text: string): React.ReactNode {
  return text.split("\n").map((paragraph: string) => {
    return <p key={uuidv4()}>{paragraph}</p>;
  });
}

interface Props {
  data: AlertDialogData;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  buttonText?: string;
  handleClose: () => void;
}

/** アラートダイアログ */
export function AlertDialog(props: Props) {
  const classes = useStyles();

  const { data, maxWidth, buttonText, handleClose } = props;

  //--------------------
  // コンポーネント
  return (
    <div>
      <Dialog
        open={data.open}
        onClose={() => {
          handleClose();
        }}
        maxWidth={maxWidth || "md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.titleRoot}>
          <span className={classes.titleText}>{data.title}</span>
        </DialogTitle>
        <DialogContent className={classes.contentRoot}>
          <DialogContentText className={classes.contentText} component="div">
            {typeof data.message === "string"
              ? toParagraph(data.message)
              : data.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {buttonText || "OK"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
